<div class="content" [ngStyle]="data.styles">
  <div class="content__close" (click)="onNoClick()">
    <img src="../../../assets/img/icons/blue-X.svg">
  </div>
  <div class="content__container">
    <p class="content__container__tag">{{data.tag}}</p>
    <h3 class="content__container__title">{{data.title}}</h3>
    @if (data.showEmail) {
      <div class="content__container__email">
        <app-email-form id="email__form" [showOkButton]="true"></app-email-form>
      </div>
    }
    <div class="content__container__text">
      @for (text of data.content; track text) {
        <div>
          <p class="content__container__text__item" [innerHTML]="text"></p>
        </div>
      }
    </div>
  </div>
  @if (!data.showEmail) {
    <div class="content__btn">
      <button (click)="onNoClick()" class="content__btn__close">OK</button>
    </div>
  }
</div>
